"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestApproval = void 0;
const request_formatters_1 = require("../request-formatters");
const response_formatters_1 = require("../response-formatters");
exports.requestApproval = {
    request: (params, collectionId) => {
        const collection = (0, request_formatters_1.getPrincipal)(collectionId);
        return [collection, params.amount];
    },
    response: (response) => {
        return (0, response_formatters_1.getResultStatus)(response, (data) => data);
    }
};
